import { Directive, ElementRef, HostListener, Input } from "@angular/core";

@Directive({
  selector: "[appTwoDigitDecimalNumber]",
})
export class TwoDigitDecimalNumberDirective {
  @Input("appTwoDigitDecimalNumber") isTripleDecimal: boolean;

  private regex: RegExp;

  // private regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/g);
  private specialKeys: Array<string> = [
    "Backspace",
    "Tab",
    "End",
    "Home",
    "ArrowLeft",
    "ArrowRight",
    "Del",
    "Delete",
  ];

  ngAfterViewInit() {
    if (this.isTripleDecimal) {
      this.regex = new RegExp(/^\d*\.?\d{0,3}$/g);
    } else {
      this.regex = new RegExp(/^\d*\.?\d{0,2}$/g);
    }
  }
  constructor(private el: ElementRef) {}
  @HostListener("keydown", ["$event"])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [
      current.slice(0, position),
      event.key == "Decimal" ? "." : event.key,
      current.slice(position),
    ].join("");
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}
